import type { RouteRecordRaw } from 'vue-router'

// 不加载Layout的路由
const noLayoutRoutes: RouteRecordRaw[] = [
  {
    path: '/main_business/no_layout_contract_detail/:id',
    name: 'mainBusinessNoLayoutContractDetail',
    component: () => import('@/views/main_business/contract_detail.vue'),
    meta: {
      title: '合同详情',
      menu: false,
      auth: [
          'Business.MainBusiness.menu'
      ]
    },
  },
  {
    path: '/main_business/no_layout_supplement_detail/:id',
    name: 'mainBusinessNoLayoutSupplementDetail',
    component: () => import('@/views/main_business/supplement_detail.vue'),
    meta: {
      title: '补充合同详情',
      menu: false,
      auth: [
          'Business.MainBusiness.menu'
      ]
    },

  },
  {
    path: '/main_business/no_layout_year_detail/:id',
    name: 'mainBusinessNoLayoutYearDetail',
    component: () => import('@/views/business/year_frame_detail.vue'),
    meta: {
      title: '年框详情',
      menu: false,
      auth: [
          'Business.MainBusiness.menu'
      ]
    },

  }
  
]

export default noLayoutRoutes
